module.exports = Vuex;